import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardMedia, CardContent, Typography, makeStyles, CardActions, Button, Box, IconButton, Collapse} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import logo from '../img/kaden_reizouko_open.png';
import clsx from 'clsx';
import { storage } from '../firebase';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 200,
        backgroundColor: "lightsteelblue"
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
    button: {
        backgroundColor: "#3f51b5",
        '&:hover': {
            backgroundColor: '#3f51b5',
        },
        color: "#ffffff"
    },
    wrappedButton: {
        justifyContent: "center"
    },
    expandingButton: {
        marginLeft: "auto",
    }
}));

const CleaningCard = (props) => {

    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    
    // WARN:この処理はTemplateには入れては行けないと思うから考慮するべき
    // Card内の画像をStorageから読み込む処理
    const [imageUrl, setImageUrl] = useState(undefined);
    useEffect(() => {
        storage
            .ref(props.imagePath)
            .getDownloadURL()
            .then((url) => {
                setImageUrl(url)
            })
            .catch((e) => console.log('Errors while storage connecting => ', e));
    }, [])
    
    return (
        <Card className={classes.root}>
            {/* Header */}
            <CardHeader
                title={props.subject}
                subheader={"難易度"  +  props.difficulity}
            />
            {/* image */}
            {imageUrl ? (
                <CardMedia
                    className={classes.media}
                    image={imageUrl}
                    title={props.subject}
                />
            ) : (<></>)}
            {/* expand content button */}
            <CardActions disableSpacing>
                <IconButton
                    className={clsx(classes.expand, {
                        [classes.expandOpen]: expanded,
                    })}
                    className={classes.expandingButton}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                <ExpandMoreIcon />
            </IconButton>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    {props.content}
                </Typography>
                </CardContent>
                <CardContent>
                    <Box border={1} borderColor="primary.main" p={0.3} width="90%">
                        <Typography color="initial" component="p" variant="body2">
                        {props.subject}　掃除
                        </Typography>
                    </Box>
                </CardContent>
                <CardActions className={classes.wrappedButton}>
                    <Button size="small" className={classes.button} target="_blank" href={`http://www.google.com/search?q=${props.subject}+掃除`}>google検索</Button>
                </CardActions>
            </Collapse>
        </Card>
    )
}
export default CleaningCard;